import { ReactNode, useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { useChatLauncherContext } from "@/src/shared/ChatLauncher/ChatLauncherContext";
import ChatHeader from "./ChatHeader/ChatHeader";
import ChatContent from "./ChatContent/ChatContent";
import ChatFooter from "./ChatFooter/ChatFooter";

const ChatWidget = (): ReactNode => {
  const { isOpen } = useChatLauncherContext();
  const [isVisible, setIsVisible] = useState<boolean>(isOpen);
  const [isClosing, setIsClosing] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setIsClosing(false);
    } else {
      setIsClosing(true);
      setTimeout(() => setIsVisible(false), 300);
    }
  }, [isOpen]);

  return (
    <StyledChatWidget isVisible={isVisible} isClosing={isClosing}>
      <ChatHeader />
      <ChatContent />
      <ChatFooter />
    </StyledChatWidget>
  );
};

const slideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const fadeOutDown = keyframes`
    from {
        opacity: 1;
        transform: translateY(0);
    }
    to {
        opacity: 0;
        transform: translateY(20px);
    }
`;

const StyledChatWidget = styled.div<{ isVisible: boolean; isClosing: boolean }>`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 10001;
  min-height: 350px;
  height: 80vh;
  max-height: 1000px;
  width: 390px;
  margin-right: 14px;
  margin-bottom: 10px;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0 10px 27px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  opacity: ${({ isClosing }) => (isClosing ? 0 : 1)};
  transform: ${({ isClosing }) => (isClosing ? "translateY(20px)" : "translateY(0)")};
  animation: ${({ isClosing }) => (isClosing ? fadeOutDown : slideUp)} 0.3s ease-out;
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  @media only screen and (max-width: 767px) {
    width: calc(100vw - 28px);
    height: calc(100vh - 28px);
    max-height: 100%;
  }
`;

export default ChatWidget;
